export const onInitService = ({ getConfig, setContext }) => {
  setContext(
    "one.axios.proxy.baseUrl",
    getConfig("one.axios.proxy.baseUrl", "/api")
  );

  setContext(
    "one.rest.header.accessToken.key",
    getConfig("one.rest.header.accessToken.key", "Authorization")
  );

  setContext(
    "one.axios.sessions.param.key",
    getConfig("one.axios.sessions.param.key", "ctx")
  );

  setContext(
    "one.axios.useLightJump",
    getConfig("one.axios.dangerouslyUseLightJump", false)
  );
};
